__turbopack_context__.v({
  "body": "cardOverlay-module__khH62W__body",
  "button": "cardOverlay-module__khH62W__button",
  "buttons": "cardOverlay-module__khH62W__buttons",
  "description": "cardOverlay-module__khH62W__description",
  "title": "cardOverlay-module__khH62W__title",
});
